export default __webpack_public_path__ + "static/media/ketogo-subexpired@3x.effc6654.png";